import { render, staticRenderFns } from "./ChirpListClient.vue?vue&type=template&id=a5a3b13a"
import script from "./ChirpListClient.vue?vue&type=script&lang=js"
export * from "./ChirpListClient.vue?vue&type=script&lang=js"
import style0 from "./ChirpListClient.vue?vue&type=style&index=0&id=a5a3b13a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports